import { motion } from "framer-motion";
import { SITE, PARTNERS } from "@/data/site";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="relative bg-[var(--ink)] text-white pt-16 md:pt-24 pb-6 border-t border-white/10 overflow-hidden"
    >
        <div className="container-x">
            {/* Partners strip */}
            <div
                data-testid="partners-strip"
                className="border-t border-b border-white/10 py-8 mb-16 flex flex-wrap items-center gap-x-10 gap-y-4"
            >
                <span className="font-display text-[11px] tracking-[0.32em] uppercase text-[var(--sun)]">
                    Apoio · Parceiros ·
                </span>
                {PARTNERS.map((p) => (
                    <span
                        key={p}
                        className="font-editorial italic text-lg md:text-xl text-white/80"
                    >
                        {p}
                    </span>
                ))}
            </div>

            <div className="grid grid-cols-12 gap-6 mb-16">
                <div className="col-span-12 md:col-span-5">
                    <div className="flex items-center gap-4 mb-6">
                        <img
                            src="/logo.png"
                            alt="Logo Novo Horizonte F.C."
                            className="h-14 w-14 object-contain"
                        />
                        <div>
                            <div className="font-display text-[11px] tracking-[0.32em] uppercase text-white/50">
                                AENHCC · {SITE.since}
                            </div>
                            <div className="font-body text-[11px] text-white/40 mt-1">
                                Novo Horizonte F.C.
                            </div>
                        </div>
                    </div>
                    <p className="font-editorial italic text-2xl md:text-3xl leading-tight max-w-md">
                        {SITE.fullName}.
                    </p>
                </div>

                <div className="col-span-6 md:col-span-3 md:col-start-7">
                    <div className="font-display text-[11px] tracking-[0.32em] uppercase text-white/50 mb-4">
                        Navegar
                    </div>
                    <ul className="space-y-2 font-body text-[14px]">
                        {[
                            ["historia", "Nossa História"],
                            ["acoes", "Nossas Ações"],
                            ["galeria", "Galeria"],
                            ["membro", "Seja Membro"],
                            ["contato", "Contato"],
                        ].map(([id, label]) => (
                            <li key={id}>
                                <a
                                    href={`#${id}`}
                                    data-testid={`footer-link-${id}`}
                                    className="link-sweep text-white/80 hover:text-white"
                                >
                                    {label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="font-display text-[11px] tracking-[0.32em] uppercase text-white/50 mb-4">
                        Contato
                    </div>
                    <ul className="space-y-2 font-body text-[14px] text-white/80">
                        {SITE.phones.map((p) => (
                            <li key={p}>
                                <a
                                    href={`tel:${p.replace(/\D/g, "")}`}
                                    className="link-sweep"
                                >
                                    {p}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                href={SITE.instagram}
                                target="_blank"
                                rel="noreferrer"
                                className="link-sweep"
                            >
                                Instagram
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Monster brand */}
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
                className="relative overflow-hidden -mx-6 md:-mx-12"
            >
                <div className="footer-monster text-[20vw] md:text-[16vw] text-white/95 select-none whitespace-nowrap px-6 md:px-12 leading-[0.8]">
                    NOVO&nbsp;
                    <span className="font-editorial italic font-medium text-[var(--sun)] normal-case tracking-tight">
                        horizonte
                    </span>
                </div>
            </motion.div>

            <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 pt-6 border-t border-white/10 text-[10px] tracking-[0.32em] uppercase text-white/50 font-body">
                <span>
                    © {new Date().getFullYear()} {SITE.brandShort}. Todos os
                    direitos reservados.
                </span>
                <span>CNPJ {SITE.cnpj}</span>
                <span>Feito com propósito · {SITE.location}</span>
            </div>
        </div>
    </footer>
);
